import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

function CSSAnimation({
	children,
	isMounted,
	mountClassName = '',
	unmountClassName = '',
	delayUntilUnmountInMillis,
}) {

	const [shouldRender, setShouldRender] = useState(false);

	useEffect(() => {
		let timeoutId;
		if (isMounted && !shouldRender) {
			setShouldRender(true);
		} else if (!isMounted && shouldRender) {
			timeoutId = setTimeout(
				() => setShouldRender(false),
				delayUntilUnmountInMillis
			);
		}
		return () => clearTimeout(timeoutId);
	}, [isMounted, delayUntilUnmountInMillis, shouldRender]);

	return (
		<>
			{shouldRender && (
				<div
					className={isMounted ? mountClassName : unmountClassName}
					data-testid={'cssAnimation'}
				>
					{children}
				</div>
			)}
		</>
	);
}

export default CSSAnimation;

CSSAnimation.propTypes = {
	children: PropTypes.node.isRequired,
	isMounted: PropTypes.bool.isRequired,
	mountClassName: PropTypes.string,
	unmountClassName: PropTypes.string,
	delayUntilUnmountInMillis: PropTypes.number.isRequired,
};